<template>
  <div class="sales">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <!--<div v-else-if="beforeFirstJanuary2019">-->
    <div v-else>
      <v-card class="mb-3">
      <v-flex  xs12>
        <v-expansion-panel
          v-model="panel"
          expand
        >
          <v-expansion-panel-content>
            <div slot="header">
              <v-flex d-flex xs12>
                <v-layout row wrap class="itemVente">
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('sales', 2, {count: ''}) + " chat" | cap }}</div>
                    <div class="ml-4 headline teal--text">{{ nbSales }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('items', 2, {count: ''}) + " chat" | cap }}</div>
                    <div class="ml-4 headline blue--text">{{ nbItems }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('amount') + " chat" | cap }}</div>
                    <div class="ml-4 headline pink--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(nbAmount) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('averageBasket') + " chat" | cap }}</div>
                    <div class="ml-4 headline deep-orange--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(panierMoyen) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">{{ $t('conversionRate') + ' chat' | cap }}</div>
                        <div class="ml-4 headline white--text">{{ nbConversion }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">% du Chiffre d'Affaire total</div>
                        <div class="ml-4 headline white--text">{{ ratioChatTotal }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <v-card>
              <v-card-text class="">
                <highcharts :options="options"></highcharts>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content
            v-if="brideMenu('stats_ventes_chatbot') === '1'"
          >
            <div slot="header">
              <v-flex d-flex xs12>
                <v-layout row wrap class="itemVente">
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('sales', 2, {count: ''}) + " chatbot" | cap }}</div>
                    <div class="ml-4 headline teal--text">{{ nbSalesBot }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('items', 2, {count: ''}) + " chatbot" | cap }}</div>
                    <div class="ml-4 headline blue--text">{{ nbItemsBot }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('amount') + " chatbot" | cap }}</div>
                    <div class="ml-4 headline pink--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(nbAmountBot) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('averageBasket') + " chatbot" | cap }}</div>
                    <div class="ml-4 headline deep-orange--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(panierMoyenBot) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">{{ $t('conversionRate') + ' chatbot' | cap }}</div>
                        <div class="ml-4 headline white--text">{{ nbConversionBot }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">% du Chiffre d'Affaire total</div>
                        <div class="ml-4 headline white--text">{{ ratioBotTotal }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <v-card>
              <v-card-text class="">
                <highcharts :options="optionsChatBot"></highcharts>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content
            v-if="brideMenu('parametre_connecteur_apz') === '1'"
          >
            <div slot="header">
              <v-flex d-flex xs12>
                <v-layout row wrap class="itemVente">
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('sales', 2, {count: ''}) + " visio" | cap }}</div>
                    <div class="ml-4 headline teal--text">{{ nbSalesVisio }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('items', 2, {count: ''}) + " visio" | cap }}</div>
                    <div class="ml-4 headline blue--text">{{ nbItemsVisio }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('amount') + " visio" | cap }}</div>
                    <div class="ml-4 headline pink--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(nbAmountVisio) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('averageBasket') + " visio" | cap }}</div>
                    <div class="ml-4 headline deep-orange--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(panierMoyenVisio) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">{{ $t('conversionRate') + ' visio' | cap }}</div>
                        <div class="ml-4 headline white--text">{{ nbConversionVisio }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">% du Chiffre d'Affaire total</div>
                        <div class="ml-4 headline white--text">{{ ratioVisioTotal }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <v-card>
              <v-card-text class="">
                <highcharts :options="optionsVisio"></highcharts>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content
            v-if="brideMenu('stats_ventes_callback') === '1'"
          >
            <div slot="header">
              <v-flex d-flex xs12>
                <v-layout row wrap class="itemVente">
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('sales', 2, {count: ''}) + " Call back" | cap }}</div>
                    <div class="ml-4 headline teal--text">{{ nbSalesC2C }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $tc('items', 2, {count: ''}) + " Call back" | cap }}</div>
                    <div class="ml-4 headline blue--text">{{ nbItemsC2C }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">{{ $t('amount') + " Call back" | cap }}</div>
                    <div class="ml-4 headline pink--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(nbAmountC2C) }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                        <div class="ml-4 grey--text text--darken-2">{{ $t('averageBasket') + " Call back" | cap }}</div>
                        <div class="ml-4 headline deep-orange--text">{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(panierMoyenC2C) }}</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">{{ $t('conversionRate') + ' Call back' | cap }}</div>
                        <div class="ml-4 headline white--text">{{ nbConversionC2C }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">% du Chiffre d'Affaire total</div>
                        <div class="ml-4 headline white--text">{{ ratioC2CTotal }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <v-card>
              <v-card-text class="">
                <highcharts :options="optionsC2C"></highcharts>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <v-expansion-panel-content
            v-if="brideMenu('stats_ventes_lead') === '1'"
          >
            <div slot="header">
              <v-flex d-flex xs12>
                <v-layout row wrap class="itemVente">
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2">Acquisitions Leads</div>
                    <div class="ml-4 headline teal--text">{{ nbSalesLead }}</div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2"></div>
                    <div class="ml-4 headline blue--text"></div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                    <div class="ml-4 grey--text text--darken-2"></div>
                    <div class="ml-4 headline pink--text"></div>
                    </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs2>
                    <v-card flat>
                      <v-card-text>
                        <div class="ml-4 grey--text text--darken-2"></div>
                        <div class="ml-4 headline deep-orange--text"></div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs4>
                    <v-card color="primary" dark>
                      <v-card-text>
                        <div class="ml-4 white--text">{{ $t('conversionRate') + ' Lead' | cap }}</div>
                        <div class="ml-4 headline white--text">{{ nbConversionLead }} %</div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </div>
            <v-card>
              <v-card-text class="">
                <highcharts :options="optionsLead"></highcharts>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

        </v-expansion-panel>
      </v-flex>
    </v-card>

      <v-card class="mb-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 sm10 class="headline">{{ $t('salesDetails') | cap }}</v-flex>
            <v-flex xs6 sm2>
              <v-btn
                color="primary"
                dark
                slot="activator"
                flat
                @click="download()"
                :disabled="salesDetails.length == 0"
              >
                {{ $t('exportInCsv') }}
                <v-icon color="primary" right>file_download</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headersSalesDetails"
            :items="salesDetails"
            :no-data-text="$tc('sales', 0)"
            :no-results-text="$tc('results', 0)"
            :rows-per-page-items="[10, 25, 50, { text: 'Toutes', value: -1 }]"
            :rows-per-page-text="$t('salesPerPage')"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.visitorId }}</td>
              <td>{{ props.item.saleId }}</td>
              <td>{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(props.item.amount) }}</td>
              <td>{{ props.item.items }}</td>
              <td>{{ props.item.agent }}</td>
              <td>{{ props.item.canal }}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-card class="mb-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 sm10 class="headline">{{ $t('salesTad') }}</v-flex>
            <v-flex xs6 sm2>
              <v-btn
                color="primary"
                dark
                slot="activator"
                flat
                @click="downloadtag()"
                :disabled="tagDetails.length == 0"
              >
                {{ $t('exportInCsv') }}
                <v-icon color="primary" right>file_download</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headersSalesDetailsTag"
            :items="tagDetails"
            :no-data-text="$tc('sales', 0)"
            :no-results-text="$tc('results', 0)"
            :rows-per-page-items="[10, 25, 50, { text: 'Toutes', value: -1 }]"
            :rows-per-page-text="$t('salesPerPage')"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.visitorId }}</td>
              <td>{{ props.item.saleId }}</td>
              <td>{{ Intl.NumberFormat(lang, {style: 'currency', currency: currency}).format(props.item.amount) }}</td>
              <td>{{ props.item.items }}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-card class="mb-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 sm10 class="headline">Push produit : mise au panier</v-flex>
          </v-layout>
          <v-data-table
            :headers="headersPushProduct"
            :items="pushDetails"
            :no-data-text="$tc('sales', 0)"
            :no-results-text="$tc('results', 0)"
            :rows-per-page-items="[10, 25, 50, { text: 'Toutes', value: -1 }]"
            :rows-per-page-text="$t('salesPerPage')"
          >
            <template slot="headerCell" slot-scope="props">
              <span>{{ props.header.text }}</span>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.visitorId }}</td>
              <td>{{ props.item.productId }}</td>
              <td>{{ props.item.agent }}</td>
              <td>{{ props.item.success }}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
    <!--<wz-sales-2019 v-else :sales="resFromAjax" :options="options"/>-->
  </div>
</template>

<style>
  .itemVente:hover {background-color: #e5e5e5;}
  .itemVente .theme--light.v-card {background-color: inherit !important;}
</style>

<script>
import _ from 'lodash'
import * as moment from 'moment'
import { mapGetters, mapState } from 'vuex'

/* import WzSales2019 from '../stats/WzSales2019' */

export default {
 /* components: {
    WzSales2019
  }, */

  data () {
    return {
      panel: [true, false, false],
      periode: '',
      loading: false,
      resFromAjax: null,
      nbSales: 0,
      nbItems: 0,
      nbAmount: 0,
      nbSupports: 0,
      nbSalesBot: 0,
      nbItemsBot: 0,
      nbAmountBot: 0,
      nbSalesVisio: 0,
      nbItemsVisio: 0,
      nbAmountVisio: 0,
      nbSalesC2C: 0,
      nbItemsC2C: 0,
      nbAmountC2C: 0,
      nbSalesLead: 0,
      nbItemsLead: 0,
      nbAmountLead: 0,
      nbChats: 0,
      nbFirstTimeResponse: 0,
      nbConversion: 0,
      nbConversionBot: 0,
      nbConversionVisio: 0,
      nbConversionC2C: 0,
      nbConversionLead: 0,
      ratioChatTotal: 0,
      ratioBotTotal: 0,
      ratioVisioTotal: 0,
      ratioC2CTotal: 0,
      lang: this.$store.state._User.lang + '-' + this.$store.state._User.licLang,
      currency: 'EUR',
      // data chat
      options: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#009688' // teal
              }
            },
            title: {
              text: _.upperFirst(this.$tc('sales', 2, {count: ''})),
              style: {
                color: '#009688' // teal
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#2196F3' // blue
              }
            },
            title: {
              text: _.upperFirst(this.$tc('items', 2, {count: ''})),
              style: {
                color: '#2196F3' // blue
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              // formatter: function () { // formatage du montant
              //   let s = Intl.NumberFormat('fr-FR', {style: 'currency', currency: 'EUR'}).format(this.value)
              //   return s
              // },
              style: {
                color: '#E91E63' // pink
              }
            },
            title: {
              text: _.upperFirst(this.$tc('amount', 2, {count: ''})) + ' (€)',
              style: {
                color: '#E91E63' // pink
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: _.upperFirst(this.$tc('sales', 2, {count: ''})) + ' chat',
            type: 'spline',
            color: '#009688', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$tc('items', 2, {count: ''})) + ' chat',
            type: 'spline',
            color: '#2196F3', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 1,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$t('amount')) + ' chat',
            type: 'spline',
            color: '#E91E63', // pink
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: ' €' },
            yAxis: 2,
            data: [] // à remplir par l'appel ajax
          }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      // data chatbot
      optionsChatBot: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#009688' // teal
              }
            },
            title: {
              text: _.upperFirst(this.$tc('sales', 2, {count: ''})),
              style: {
                color: '#009688' // teal
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#2196F3' // blue
              }
            },
            title: {
              text: _.upperFirst(this.$tc('items', 2, {count: ''})),
              style: {
                color: '#2196F3' // blue
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#E91E63' // pink
              }
            },
            title: {
              text: _.upperFirst(this.$tc('amount', 2, {count: ''})) + ' (€)',
              style: {
                color: '#E91E63' // pink
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: _.upperFirst(this.$tc('sales', 2, {count: ''})) + ' chatbot',
            type: 'spline',
            color: '#009688', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$tc('items', 2, {count: ''})) + ' chatbot',
            type: 'spline',
            color: '#2196F3', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 1,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$t('amount')) + ' chatbot',
            type: 'spline',
            color: '#E91E63', // pink
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: ' €' },
            yAxis: 2,
            data: [] // à remplir par l'appel ajax
          }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },
      // data chatbot
      optionsVisio: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#009688' // teal
              }
            },
            title: {
              text: _.upperFirst(this.$tc('sales', 2, {count: ''})),
              style: {
                color: '#009688' // teal
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#2196F3' // blue
              }
            },
            title: {
              text: _.upperFirst(this.$tc('items', 2, {count: ''})),
              style: {
                color: '#2196F3' // blue
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#E91E63' // pink
              }
            },
            title: {
              text: _.upperFirst(this.$tc('amount', 2, {count: ''})) + ' (€)',
              style: {
                color: '#E91E63' // pink
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: _.upperFirst(this.$tc('sales', 2, {count: ''})) + ' visio',
            type: 'spline',
            color: '#009688', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$tc('items', 2, {count: ''})) + ' visio',
            type: 'spline',
            color: '#2196F3', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 1,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$t('amount')) + ' visio',
            type: 'spline',
            color: '#E91E63', // pink
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: ' €' },
            yAxis: 2,
            data: [] // à remplir par l'appel ajax
          }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      // data click to call
      optionsC2C: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#009688' // teal
              }
            },
            title: {
              text: _.upperFirst(this.$tc('sales', 2, {count: ''})),
              style: {
                color: '#009688' // teal
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#2196F3' // blue
              }
            },
            title: {
              text: _.upperFirst(this.$tc('items', 2, {count: ''})),
              style: {
                color: '#2196F3' // blue
              }
            },
            opposite: false
          }, { // valeurs flotantes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#E91E63' // pink
              }
            },
            title: {
              text: _.upperFirst(this.$tc('amount', 2, {count: ''})) + ' (€)',
              style: {
                color: '#E91E63' // pink
              }
            },
            opposite: true
          }
        ],
        series: [
          {
            name: _.upperFirst(this.$tc('sales', 2, {count: ''})) + ' ' + this.$t('C2C'),
            type: 'spline',
            color: '#009688', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$tc('items', 2, {count: ''})) + ' ' + this.$t('C2C'),
            type: 'spline',
            color: '#2196F3', // blue
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 1,
            data: [] // à remplir par l'appel ajax
          },
          {
            name: _.upperFirst(this.$t('amount')) + ' ' + this.$t('C2C'),
            type: 'spline',
            color: '#E91E63', // pink
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: ' €' },
            yAxis: 2,
            data: [] // à remplir par l'appel ajax
          }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      // data Lead
      optionsLead: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 // center
        },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // à remplir par l'appel ajax
        },
        yAxis: [
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: '#009688' // teal
              }
            },
            title: {
              text: 'Leads',
              style: {
                color: '#009688' // teal
              }
            },
            opposite: false
          }
        ],
        series: [
          {
            name: 'Acquisition Lead',
            type: 'spline',
            color: '#009688', // teal
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            tooltip: { valueSuffix: '' },
            yAxis: 0,
            data: [] // à remplir par l'appel ajax
          }
        ],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },
      /**
       * variables liées au tableau du détails des ventes
       */
      headersSalesDetails: [
        { text: 'Date', value: 'date', align: 'left' },
        { text: 'ID ' + this.$tc('visitors', 1, {count: ''}), value: 'visitorId' },
        { text: 'ID ' + this.$tc('sales', 1, {count: ''}), value: 'saleId' },
        { text: _.upperFirst(this.$t('amount')), value: 'amount' },
        { text: _.upperFirst(this.$tc('items', 1, {count: ''})), value: 'items' },
        { text: _.upperFirst(this.$tc('agents', 1, {count: ''})), value: 'agent' },
        { text: 'Canal', value: 'canal' }
      ],
      /**
       * variables liées au tableau du détails des ventes
       */
      headersSalesDetailsTag: [
        { text: 'Date', value: 'date', align: 'left' },
        { text: 'ID ' + this.$tc('visitors', 1, {count: ''}), value: 'visitorId' },
        { text: 'ID ' + this.$tc('sales', 1, {count: ''}), value: 'saleId' },
        { text: _.upperFirst(this.$t('amount')), value: 'amount' },
        { text: _.upperFirst(this.$tc('items', 1, {count: ''})), value: 'items' }
      ],
      /**
       * variables liées au push produits mis au maniers
       */
      headersPushProduct: [
        { text: 'Date', value: 'date', align: 'left' },
        { text: 'ID ' + this.$tc('visitors', 1, {count: ''}), value: 'visitorId' },
        { text: 'Ref ' + this.$t('produit'), value: 'productId' },
        { text: _.upperFirst(this.$tc('agents', 1, {count: ''})), value: 'agent' },
        { text: 'Probable commande (ref)', value: 'success' }
      ],
      salesDetails: [],
      tagDetails: [],
      pushDetails: []
    }
  },

  /* created () { */
  mounted () {
    // si les filtres sont chargés, il est possible de lancer la/les requêtes afin de remplir les stats
    this.loading = true
    this.getSales()
    this.panel = [true, false, false]

    // la période affiché
    let paramsArray = this.params.split('=')
    let debut = paramsArray[1].substring(0, 10)
    let fin = paramsArray[2].substring(0, 10)
    this.periode = '_du_' + debut + '_au_' + fin + '.csv'
    // console.log('periode', this.periode)
    // this.getSales()
  },

  computed: {
    ...mapState('_User', ['brides']),
    ...mapGetters('_Stats', ['params']),
    ...mapGetters('_Sites', ['HAS_ONE_FUNNEL']),
    ...mapGetters('_Sites', ['HAS_CALLBACK_ACTIVATED']),
    ...mapGetters('_Sites', ['HAS_VISIO_ACTIVATED']),
    ...mapGetters('_Sites', ['HAS_BOT_ACTIVATED']),
    ...mapState('_User', ['brides']),

    // console.log(new Intl.NumberFormat(this.lang, {style: 'currency,' currency: 'EUR'}).format(nombre));

    panierMoyen () {
      return !this.nbSales ? 0 : _.round(this.nbAmount / this.nbSales, 2)
    },
    panierMoyenBot () {
      return !this.nbSalesBot ? 0 : _.round(this.nbAmountBot / this.nbSalesBot, 2)
    },
    panierMoyenVisio () {
      return !this.nbSalesVisio ? 0 : _.round(this.nbAmountVisio / this.nbSalesVisio, 2)
    },
    panierMoyenC2C () {
      return !this.nbSalesC2C ? 0 : _.round(this.nbAmountC2C / this.nbSalesC2C, 2)
    },
    panierMoyenLead () {
      return !this.nbSalesLead ? 0 : _.round(this.nbAmountLead / this.nbSalesLead, 2)
    }/* ,
    beforeFirstJanuary2019 () {
      const dateStart = this.$store.state._Stats.dateStart.split('T')[0]
      const dateStartToCompare = moment(dateStart)
      const firstJanuary2019 = moment('2019-01-01')
      return dateStartToCompare.isBefore(firstJanuary2019)
    } */
  },

  methods: {
    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },

    getSales () {
      this.loading = true
      let licAllKeys = this.$store.state._User.licAllKeys.join(',')
      // execution de la requête en fonction des filtres
      this.axios.get('get/sales.php?' + this.params + '&HAS_ONE_FUNNEL=' + this.HAS_ONE_FUNNEL + '&HAS_CALLBACK_ACTIVATED=' + this.HAS_CALLBACK_ACTIVATED + '&HAS_BOT_ACTIVATED=' + this.HAS_BOT_ACTIVATED + '&HAS_VISIO_ACTIVATED=' + this.HAS_VISIO_ACTIVATED + '&licAllKeys=' + licAllKeys)
      .then(response => {
        this.resFromAjax = response.data

        this.nbSales = this.resFromAjax.nbSales
        this.nbItems = this.resFromAjax.nbItems
        this.nbAmount = this.resFromAjax.nbAmount
        this.nbSalesBot = this.resFromAjax.nbSalesBot
        this.nbItemsBot = this.resFromAjax.nbItemsBot
        this.nbAmountBot = this.resFromAjax.nbAmountBot
        this.nbSalesVisio = this.resFromAjax.nbSalesVisio
        this.nbItemsVisio = this.resFromAjax.nbItemsVisio
        this.nbAmountVisio = this.resFromAjax.nbAmountVisio

        this.nbSalesC2C = this.resFromAjax.nbSalesC2C
        this.nbItemsC2C = this.resFromAjax.nbItemsC2C
        this.nbAmountC2C = this.resFromAjax.nbAmountC2C
        this.nbSalesLead = this.resFromAjax.nbSalesLead
        this.nbItemsLead = this.resFromAjax.nbItemsLead
        this.nbAmountLead = this.resFromAjax.nbAmountLead
        this.nbSupports = this.resFromAjax.nbSupports
        this.nbChats = this.resFromAjax.nbChats
        this.nbFirstTimeResponse = this.resFromAjax.nbFirstTimeResponse
        this.nbConversion = this.resFromAjax.nbConversion
        this.nbConversionBot = this.resFromAjax.nbConversionBot
        this.nbConversionVisio = this.resFromAjax.nbConversionVisio
        this.nbConversionC2C = this.resFromAjax.nbConversionC2C
        this.nbConversionLead = this.resFromAjax.nbConversionLead

        this.ratioChatTotal = this.resFromAjax.ratioChatTotal
        this.ratioBotTotal = this.resFromAjax.ratioBotTotal
        this.ratioVisioTotal = this.resFromAjax.ratioVisioTotal
        this.ratioC2CTotal = this.resFromAjax.ratioC2CTotal

        this.options.xAxis.categories = []
        this.options.series[0].data = []
        this.options.series[1].data = []
        this.options.series[2].data = []

        this.optionsChatBot.xAxis.categories = []
        this.optionsChatBot.series[0].data = []
        this.optionsChatBot.series[1].data = []
        this.optionsChatBot.series[2].data = []

        this.optionsVisio.xAxis.categories = []
        this.optionsVisio.series[0].data = []
        this.optionsVisio.series[1].data = []
        this.optionsVisio.series[2].data = []

        this.optionsC2C.xAxis.categories = []
        this.optionsC2C.series[0].data = []
        this.optionsC2C.series[1].data = []
        this.optionsC2C.series[2].data = []

        this.optionsLead.xAxis.categories = []
        this.optionsLead.series[0].data = []

        this.salesDetails = []
        this.tagDetails = []
        this.pushDetails = []

        // parcours du tableau des infos par jour afin de remplir le graphique et le détail des ventes
        // ne commence qu'à partir de l'indice 31 afin de ne récupérer que les 30 derniers jours
        for (let i = 31; i < this.resFromAjax.days.length; i++) {
          let day = this.resFromAjax.days[i]
          this.options.xAxis.categories.push(moment(day.date).format('ll'))
          this.options.series[0].data.push(day.sales.length) // Ventes
          this.options.series[1].data.push(day.items) // Articles
          this.options.series[2].data.push(day.amount) // Montant
          // détails des ventes
          _.each(day.sales, sale => {
            // récupération du nom et prénom de l'agent lié à la vente
            let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(sale.agent)})
            this.salesDetails.push({
              date: moment(day.date).format('ll'),
              visitorId: sale.vis,
              saleId: sale.id,
              amount: sale.amount,
              items: sale.items,
              agent: agentFound ? agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME : '',
              canal: 'chat'
            })
          })
        }
        // pour le chatBot uniquement si il a les droits pour l'afficher
        if (this.brideMenu('stats_ventes_chatbot') === '1') {
          for (let i = 31; i < this.resFromAjax.daysBot.length; i++) {
            let day = this.resFromAjax.daysBot[i]
            this.optionsChatBot.xAxis.categories.push(moment(day.date).format('ll'))
            this.optionsChatBot.series[0].data.push(day.sales.length) // Ventes
            this.optionsChatBot.series[1].data.push(day.items) // Articles
            this.optionsChatBot.series[2].data.push(day.amount) // Montant
            // détails des ventes
            _.each(day.sales, sale => {
              this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.vis,
                saleId: sale.id,
                amount: sale.amount,
                items: sale.items,
                agent: '',
                canal: 'chatbot'
              })
            })
          }
        }
        // pour la visio uniquement si il a les droits pour l'afficher
        if (this.brideMenu('parametre_connecteur_apz') === '1') {
          for (let i = 31; i < this.resFromAjax.daysVisio.length; i++) {
            let day = this.resFromAjax.daysVisio[i]
            this.optionsVisio.xAxis.categories.push(moment(day.date).format('ll'))
            this.optionsVisio.series[0].data.push(day.sales.length) // Ventes
            this.optionsVisio.series[1].data.push(day.items) // Articles
            this.optionsVisio.series[2].data.push(day.amount) // Montant
            // détails des ventes
            _.each(day.sales, sale => {
              let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(sale.agent)})
              this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.vis,
                saleId: sale.id,
                amount: sale.amount,
                items: sale.items,
                agent: agentFound ? agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME : '',
                canal: 'visio'
              })
            })
          }
        }
        // pour le callback uniquement si il a les droits pour l'afficher
        if (this.brideMenu('stats_ventes_callback') === '1') {
          for (let i = 31; i < this.resFromAjax.daysC2C.length; i++) {
            let day = this.resFromAjax.daysC2C[i]
            this.optionsC2C.xAxis.categories.push(moment(day.date).format('ll'))
            this.optionsC2C.series[0].data.push(day.sales.length) // Ventes
            this.optionsC2C.series[1].data.push(day.items) // Articles
            this.optionsC2C.series[2].data.push(day.amount) // Montant
            // détails des ventes
            _.each(day.sales, sale => {
              this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.vis,
                saleId: sale.id,
                amount: sale.amount,
                items: sale.items,
                agent: '',
                canal: 'Click-to-Call'
              })
            })
          }
        }
        // pour le leads uniquement si il a les droits pour l'afficher
        if (this.brideMenu('stats_ventes_lead') === '1') {
          for (let i = 31; i < this.resFromAjax.daysLead.length; i++) {
            let day = this.resFromAjax.daysLead[i]
            this.optionsLead.xAxis.categories.push(moment(day.date).format('ll'))
            this.optionsLead.series[0].data.push(day.leads.length) // Ventes

            // détails des leads
            _.each(day.leads, sale => {
              this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.lead,
                saleId: sale.id,
                agent: 'Lead'
              })
            })
          }
        }

        for (let i = 31; i < this.resFromAjax.daysTag.length; i++) {
          let day = this.resFromAjax.daysTag[i]
          // détails des ventes
          _.each(day.sales, sale => {
            this.tagDetails.push({
              date: moment(day.date).format('ll'),
              visitorId: sale.vis,
              saleId: sale.id,
              amount: sale.amount,
              items: sale.items
            })
          })
        }

        for (let i = 31; i < this.resFromAjax.daysPush.length; i++) {
          let day = this.resFromAjax.daysPush[i]
          // détails des mises au panier
          _.each(day.sales, sale => {
            let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(sale.agent)})
            this.pushDetails.push({
              date: moment(day.date).format('ll'),
              visitorId: sale.vis,
              productId: sale.productid,
              agent: agentFound ? agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME : '',
              success: sale.success === 1 ? sale.cart : ' - ',
              cart: sale.cart
            })
          })
        }
      })
      .catch(errors => {})
      .then(_ => {
        this.loading = false
      })
    },
    download () {
      let json = []
      let csv = ''
      // ajout de la ligne des titres des colonnes
      json.push([
        this.headersSalesDetails[0].text,
        this.headersSalesDetails[1].text,
        this.headersSalesDetails[2].text,
        this.headersSalesDetails[3].text,
        this.headersSalesDetails[4].text,
        this.headersSalesDetails[5].text
      ])
      // ajout de toutes les données
      for (let i = 0; i < this.salesDetails.length; i++) {
        let value = []
        value[0] = this.salesDetails[i]['date']
        value[1] = this.salesDetails[i]['visitorId']
        value[2] = this.salesDetails[i]['saleId']
        value[3] = this.salesDetails[i]['amount']
        value[4] = this.salesDetails[i]['items']
        value[5] = this.salesDetails[i]['agent']
        json.push(value)
      }
      // converion du json en csv
      for (let j = 0; j < json.length; j++) {
        csv += '"'
        for (let k = 0; k < json[j].length; k++) {
          csv += json[j][k]
          csv += (k === json[j].length - 1)
          ? '"'
          : '","'
        }
        csv += '\n'
      }
      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'ventes' + this.periode + '.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    },
    downloadtag () {
      console.log('download tag')
      let json = []
      let csv = ''
      // ajout de la ligne des titres des colonnes
      json.push([
        this.headersSalesDetailsTag[0].text,
        this.headersSalesDetailsTag[1].text,
        this.headersSalesDetailsTag[2].text,
        this.headersSalesDetailsTag[3].text,
        this.headersSalesDetailsTag[4].text
      ])
      // ajout de toutes les données
      for (let i = 0; i < this.tagDetails.length; i++) {
        let value = []
        value[0] = this.tagDetails[i]['date']
        value[1] = this.tagDetails[i]['visitorId']
        value[2] = this.tagDetails[i]['saleId']
        value[3] = this.tagDetails[i]['amount']
        value[4] = this.tagDetails[i]['items']
        json.push(value)
      }
      // converion du json en csv
      for (let j = 0; j < json.length; j++) {
        csv += '"'
        for (let k = 0; k < json[j].length; k++) {
          csv += json[j][k]
          csv += (k === json[j].length - 1)
          ? '"'
          : '","'
        }
        csv += '\n'
      }
      // téléchargement du fichier csv
      var hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
      hiddenElement.target = '_blank'
      hiddenElement.download = 'tag' + this.periode + '.csv'
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    }
  },

  watch: {
    params (v) {
      // console.log('--->v', v)
      // La période affiché
      let paramsArray = v.split('=')
      let debut = paramsArray[1].substring(0, 10)
      let fin = paramsArray[2].substring(0, 10)
      this.periode = '_du_' + debut + '_au_' + fin + '.csv'
      // console.log('periode', this.periode)
      this.getSales()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/stats/Sales.vue